import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/sitemap")({
  head: () => ({
    meta: [{ title: "Sitemap · Harbor & Pine Realty" }],
  }),
  component: SitemapPage,
})

const groups = [
  {
    title: "Find property",
    links: [
      ["/", "Property finder"],
      ["/search", "All properties"],
      ["/search?transaction=buy", "Buy"],
      ["/search?transaction=rent", "Rent"],
      ["/events", "Open houses"],
    ],
  },
  {
    title: "Company & guidance",
    links: [
      ["/about", "About"],
      ["/about/community", "Neighborhood field guides"],
      ["/news", "Field notes"],
      ["/contact", "Contact"],
      ["/about/privacy", "Privacy"],
      ["/about/terms", "Terms"],
    ],
  },
  {
    title: "Member workspace",
    links: [
      ["/login", "Sign in"],
      ["/register", "Create demo profile"],
      ["/dashboard", "Dashboard"],
      ["/favorites", "Saved properties"],
      ["/saved-searches", "Saved searches"],
      ["/alerts", "Alerts"],
      ["/my-listings", "Owner listings"],
      ["/account", "Account"],
    ],
  },
  {
    title: "Administration",
    links: [
      ["/admin", "Operations summary"],
      ["/admin/properties", "Properties"],
      ["/admin/inquiries", "Inquiries"],
      ["/admin/users", "Users & roles"],
      ["/admin/content", "Content"],
      ["/admin/taxonomies", "Taxonomies"],
      ["/admin/settings", "Settings"],
    ],
  },
] as const

function SitemapPage() {
  return (
    <div className="field-container py-14">
      <p className="field-label">Page index</p>
      <h1 className="field-heading mt-3">Sitemap</h1>
      <div className="mt-9 grid gap-px border bg-border sm:grid-cols-2 lg:grid-cols-4">
        {groups.map((group, groupIndex) => (
          <section
            key={group.title}
            className="field-rule min-h-96 bg-white p-6"
          >
            <span className="field-marker">{groupIndex + 1}</span>
            <h2 className="mt-7 font-heading text-3xl uppercase">
              {group.title}
            </h2>
            <ul className="mt-6 space-y-3">
              {group.links.map(([href, label]) => (
                <li key={href}>
                  <a href={href} className="field-link text-sm">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
      <p className="mt-6 text-sm text-muted-foreground">
        Member and administrator pages require one of the published demo
        accounts.
      </p>
    </div>
  )
}
